
import React, { useState } from "react";
import { KeyRound } from "lucide-react";
import { StandardEntityDialog } from "@/components/common/dialogs/StandardEntityDialog";
import AddClientDialog from '@/domains/clients/components/AddClientDialog';
import { useAddRentalDialog } from "./hooks/useAddRentalDialog";
import { RentalDialogSections } from "./components/RentalDialogSections";
import { iconStyles } from "@/styles/common-styles";
import { cn } from "@/lib/utils";
import { RentalFormData } from "./hooks/useRentalFormState";

interface AddRentalDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSave?: (data: unknown) => void;
  onSuccess?: () => void;
}

export function AddRentalDialog({
  isOpen,
  onClose,
  onSave,
  onSuccess
}: AddRentalDialogProps) {
  const [isAddClientDialogOpen, setIsAddClientDialogOpen] = useState(false);
  
  const {
    formData,
    selectedKits,
    setSelectedKits,
    lastAction,
    handleFieldChange,
    handleInventoryItemChange,
    handleInventoryChange,
    handleUndoLastAction,
    handleSubmit,
    isSubmitting,
    validationErrors,
    clients,
    clientsLoading,
    currentRentalPoint,
    totalAmount
  } = useAddRentalDialog({ onSave, onSuccess, onClose });

  const handleNewClientCreated = (newClientId: string) => {
    console.log('[AddRentalDialog] New client created:', newClientId);
    handleFieldChange('clientId', newClientId);
    setIsAddClientDialogOpen(false);
  };

  return (
    <>
      <StandardEntityDialog
        title="Добавить аренду"
        icon={<KeyRound className={cn(iconStyles.medium, "text-primary")} />}
        isOpen={isOpen}
        onClose={onClose}
        onSubmit={handleSubmit}
        isLoading={isSubmitting}
        validationErrors={validationErrors}
        size="standard"
      >
        <RentalDialogSections
          formData={formData}
          selectedKits={selectedKits}
          clients={clients}
          clientsLoading={clientsLoading}
          currentRentalPoint={currentRentalPoint}
          totalAmount={totalAmount}
          lastAction={lastAction}
          isEditMode={false}
          onClientChange={(clientId) => handleFieldChange('clientId', clientId)}
          onAddClient={() => setIsAddClientDialogOpen(true)}
          onDateChange={(field, value) => handleFieldChange(field as keyof RentalFormData, value)}
          onKitsChange={setSelectedKits}
          onInventoryItemChange={handleInventoryItemChange}
          onInventoryChange={handleInventoryChange}
          onUndoLastAction={handleUndoLastAction}
          onFieldChange={handleFieldChange}
        />
      </StandardEntityDialog>

      <AddClientDialog
        open={isAddClientDialogOpen}
        onOpenChange={setIsAddClientDialogOpen}
        onClientCreated={handleNewClientCreated}
      />
    </>
  );
}
